// extracted by mini-css-extract-plugin
module.exports = {"layer":"style_layer__2werx"};